<template>
  <b-card no-body class="phone-card">
    <b-card-header class="phone-header">
      <div class="header-title">
        <i class="fas fa-phone mr-2"></i>
        <strong>Canal Telefônico</strong>
      </div>
    </b-card-header>
    <b-card-body class="phone-body">
      <template v-if="!ombudsman.phoneServiceProtocol">
        <b-form-group label="Protocolo Telefônico">
          <b-form-input
            :value="phoneServiceProtocol"
            type="text"
            class="form-control"
            @input="$emit('update:phoneServiceProtocol', $event)"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Data efetiva de recebimento">
          <b-row no-gutters>
            <b-col cols="6">
              <b-form-input
                :value="phoneServiceReceiveDate"
                type="date"
                class="form-control"
                @input="$emit('update:phoneServiceReceiveDate', $event)"
              ></b-form-input>
            </b-col>
            <b-col cols="6">
              <b-form-input
                :value="phoneServiceReceiveTime"
                type="time"
                class="form-control"
                @input="$emit('update:phoneServiceReceiveTime', $event)"
              ></b-form-input>
            </b-col>
          </b-row>
        </b-form-group>
        <div class="phone-actions">
          <b-button
            variant="primary"
            :disabled="!phoneServiceProtocol"
            @click="$emit('associate')"
          >
            <i class="fas fa-link mr-1"></i>
            Associar
          </b-button>
          <b-button
            v-if="oldPhoneServiceProtocol"
            class="ml-2"
            variant="secondary"
            @click="$emit('cancel-replace')"
          >
            <i class="fas fa-times mr-1"></i>
            Cancelar
          </b-button>
        </div>
      </template>
      <template v-else>
        <b-form-group label="Protocolo Telefônico">
          <b-form-input
            type="text"
            class="form-control"
            disabled
            :value="ombudsman.phoneServiceProtocol"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Data efetiva de recebimento">
          <b-row no-gutters>
            <b-col cols="6">
              <b-form-input
                type="date"
                class="form-control"
                :value="
                  moment(ombudsman.phoneServiceReceiveDate).format('YYYY-MM-DD')
                "
                disabled
              ></b-form-input>
            </b-col>
            <b-col cols="6">
              <b-form-input
                type="time"
                class="form-control"
                :value="
                  moment(ombudsman.phoneServiceReceiveDate).format('HH:mm')
                "
                disabled
              ></b-form-input>
            </b-col>
          </b-row>
        </b-form-group>
        <div class="phone-actions">
          <b-button v-if="canEdit" variant="primary" @click="$emit('replace')">
            <i class="fas fa-edit mr-1"></i>
            Editar
          </b-button>
        </div>
      </template>
    </b-card-body>
  </b-card>
</template>

<script>
import moment from "moment/moment";

export default {
  name: "PhoneCard",
  props: {
    ombudsman: {
      type: Object,
      required: true,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    phoneServiceProtocol: {
      type: String,
      default: null,
    },
    phoneServiceReceiveDate: {
      type: String,
      default: null,
    },
    phoneServiceReceiveTime: {
      type: String,
      default: null,
    },
    oldPhoneServiceProtocol: {
      type: String,
      default: null,
    },
  },
  methods: {
    moment,
  },
};
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
